module.exports = __webpack_public_path__ + "static/media/screen.50984014.svg";